import SanitizedText from 'sanitize-text/components/SanitizedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SanitizedTranslation = ({
  content
}) => {
  if (!content) {
    return null;
  }
  const sections = content.split(/<br\/>|<br \/>/);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sections.map((section, index) => {
      return /*#__PURE__*/_jsx(SanitizedText, {
        body: section,
        formattingOptions: {
          isPlainText: false,
          shouldPreserveNewlines: true,
          shouldOpenLinksInNewTab: true
        }
      }, index);
    })
  });
};